<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App'
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Kanit:300,400&display=swap');
$blue : rgb(13, 106, 202);
$orange : #FFA800;
$orange-top : rgb(254,147,13);
$orange-bottom:  rgb(254,175,28);
$purple-top: rgb(139,98,228);
$purple-bottom: rgb(122,122,236);
$grey-top : rgb(253,253,253);
$grey-bottom: rgb(231,231,231);
$grey:#585858;
$reply :linear-gradient(180deg, #0D6ACA -34.44%, #0FB9F4 120%);
$integreat: linear-gradient(179.25deg, #9356E0 -19.35%, #6D8DF3 137.86%);
$company:linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
$CLOSED: #E70000;
$OPEN: #0D6ACA;
$ONHOLD: #FD7900;
$COMPANY-REPLY: #0FB9F4;
$ANSWERED: #0ABA06;

@media only screen and (max-width: 576px) {
  td.view.align-middle.arrow{
    text-align: center!important;
  }
  .dpNav ul.dropdown-menu.show{
    width: 200px!important;
  }
}

.box-img-m{
  border-radius: 50%;
      display: flex;
    align-content: center;
    justify-content: center;
    background:#e1e1e1;
    position: relative;
  width: 140px;
  height: 140px;
  overflow: hidden;
  -webkit-box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
  -moz-box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
  box-shadow: 0px 5px 5px 0px rgba(237,237,237,1);
}
.CLOSED{
  border-color: $CLOSED;
  white-space: nowrap;
  background-image: linear-gradient($CLOSED, $CLOSED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #FFA800;
    background-color: #FFA800;
}
.form-control:disabled, .form-control[readonly],.custom-file-input:disabled ~ .custom-file-label{
  background-color: #f3f3f3;
}

.OPEN{
  border-color: $OPEN;
  background-image: linear-gradient($OPEN, $OPEN);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ONHOLD{
   border-color: $ONHOLD;
  background-image: linear-gradient($ONHOLD, $ONHOLD);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.COMPANY-REPLY{
  border-color: $COMPANY-REPLY;
  background-image: linear-gradient($COMPANY-REPLY, $COMPANY-REPLY);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
   
    white-space: nowrap;
}
.ANSWERED{
    border-color: $ANSWERED;
  background-image: linear-gradient($ANSWERED, $ANSWERED);
  padding: 0.25rem 2.5rem;
   border-radius: 34px;
    white-space: nowrap;
}
.after-close{
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -o-transform: rotate(270deg); 
    position: fixed;
    right: -151px;
    top: 260px;
    display: flex;
    width: 336px;
    justify-content: flex-end;
    z-index: 10;
}
.btn-fix-skyblue{
    display:inline-block;
    padding: 5px 15px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: #0FB9F4;
  
}
.btn-fix-orange{
  display:inline-block;
    padding: 5px 15px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: #FD7900;
}
.orang-color{
    color:$orange
}
.bg-reply{
  background: $reply!important;
}
.bg-integreat{
    background: $integreat!important;
}
.bg-company{
    background: $company!important;
}
.bd-gray{
  border-top: 1px solid #DADADA!important;
}
.loading .align-middle,.loading strong{
  color: $blue !important;
}
// btn-outline-primary ปุ่มกรอบขาว ใส
//  <b-button>         ปุ่มสีส้มทึบ
.badge-pill{
      padding: 0.5em 1em;
}
.text-orange{
  color:#fe930d;
}
.text-dark-grey{
  color:#585858;
}
.text-back{
  color:#000;
}
.font-12 {
  font-size: 12px;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.font-18 {
  font-size: 18px;
}
.font-20 {
  font-size: 20px;
}
.font-22 {
  font-size: 22px;
}
.font-24 {
  font-size: 24px;
}
.font-26 {
  font-size: 26px;
}
.font-28 {
  font-size: 28px;
}
.font-30 {
  font-size: 30px;
}
.font-36 {
  font-size: 36px;
}
.font-60 {
  font-size: 60px;
}
.background-grey{
  min-height: 50vh
}
.custom-file{
  white-space: nowrap;
    overflow: hidden;
}
.table.b-table > thead > tr > th{
  font-weight: 400
}
#nomargin .modal-body{
  padding:0;
}
.modal-header{
    align-items: center;
}
small{
  color: grey;
  /* font-weight: inherit */
}
.badge{
   font-weight: inherit
}
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
}

h1,h2,h3,h4,h5,h6,span,div{
  font-weight: 300;
    font-family: 'Kanit', sans-serif;
}

// ปุ่มกรอบขาว
.btn-outline-primary{
      color: white !important;
    border-color: white !important;
    border-radius: 9999px !important;
    padding: 0.25rem 1.4rem;
}
.btn-outline-primary:hover{
  background-color : transparent !important;
}
// ปุ่มกรอบขาว

// ปุ่มสีส้มทึบ
.btn-secondary{
  background-color: #6c757d;
    border-color: $orange-top;
    background-image: linear-gradient($orange-top, $orange-bottom);
    border-radius: 40px !important;
}
.btn-secondary:hover{
   border-color: $orange-top;
}
//ปุ่มสีส้มทึบ

thead{
  background-image: linear-gradient($grey-top, $grey-bottom);
}
.table th, .table td{
  padding: 1rem;
}
.font-30{
  font-size:30px;
}
.table-hover tbody tr:hover{
  color: black !important;
  background-color:#EAF4FF !important;
}
.table-bordered th, .table-bordered td{
      border: 1px solid #DADADA;
}
.table-hover tbody tr{
  color:#585858
}
.table td.status{
  text-align: center;
}
.page-item.active .page-link{
  z-index: 1;
    color: #fff !important;
    background-color: #0FB9F4 !important;
    border-color: #0FB9F4 !important;
}
.page-link{
  padding: 0.5rem 0.8rem;
}
// .table-hover tbody tr:hover{
//   color:black;
// 
tr:hover .hoverblue{
  color:$blue;
  // text-decoration: underline;
 color: black;
    cursor: pointer;
}
.text-underline{
  text-decoration: underline!important;
}
.page-link{
color:$grey !important;
}

#modal-success .modal-body{
  padding: 5rem;
  text-align: center;
}
.not-shadow-active:active,.not-shadow-active:focus{
    box-shadow:none!important
}
.cr-pointer{
  cursor: pointer!important;
}
select::-webkit-input-placeholder,input::-webkit-input-placeholder, textarea::-webkit-input-placeholder{
  color: #C4C4C4!important;
  font-size: 16px!important;
  font-weight: 300!important;
}
.status-btn{
  width: 15%;
  height: 30px
}
.css-btn{
  display: flex; 
  align-items: center; 
  justify-content: center; 
  color: white;
  font-weight: 400;
}
.back-to-cat:hover{
  color: #fe930d!important;
}
.flex-center{
  display: flex; 
  align-items: center; 
  justify-content: center; 
}
.tooltip-inner{
  max-width: 350px!important;
  text-align: left!important;
}
.opacity{
  opacity: 0.6;
}
.opacity:hover{
  opacity: 1;
}
.cr-defualt{
  cursor: default!important;
}
.text-break{
  word-break: break-all!important;
  text-align: justify!important;
}
.w-100{
  width: 100%!important;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake{
  -webkit-animation-name: shake;
  animation-name: shake;
}

</style>



// WEBPACK FOOTER //
// src/App.vue